export default {
      id: "sites-icon-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "sprite.svg#sites-icon",
      toString: function () {
        return this.url;
      }
    }